import {
  SET_MAINTENANCE_MODE_ENABLED,
  SET_RETRY_AT,
} from './mutation_types'

export const mutations = {
  [SET_RETRY_AT] (state, value) {
    state.retryAt = value
  },
  [SET_MAINTENANCE_MODE_ENABLED] (state, value) {
    state.maintenanceModeEnabled = value
  },
}
